import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="bg-white text-text-black border-b border-primary sticky top-11 z-[999]">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between relative">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <Link to="/">
            <img src="/images/Logo.png" alt="Logo" className="h-16 w-40" />
          </Link>
        </div>

        {/* Hamburger Menu (mobile) */}
        <div className="lg:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-black focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

       {/* Nav Links */}
<ul
  className={`${
    isOpen ? "flex" : "hidden"
  } flex-col lg:flex lg:flex-row items-center gap-4 lg:gap-8 text-base font-medium absolute lg:static top-full left-0 w-full lg:w-auto bg-white lg:bg-transparent px-4 py-4 lg:p-0 border-t lg:border-0 z-50 transition-all duration-300`}
>
  {[
    { path: "/", label: "Home" },
    { path: "/aboutUs", label: "About" },
    { path: "/explore-books", label: "Explore Books" },
    { path: "/membershipPlans", label: "Membership Plans" },
    { path: "/suggest-book", label: "Suggest Book" },
    { separator: true }, // Insert separator here
    { path: "/donate-books", label: "Donate Books" },
    { path: "/buy-books", label: "Buy Books" },
  ].map((item, index) =>
    item.separator ? (
      <li
        key={`separator-${index}`}
        className="hidden lg:block h-5 w-px bg-slate-600"
      />
    ) : (
      <li key={item.path} className="w-full text-center lg:w-auto">
        <Link
          to={item.path}
          className={`block py-2 lg:py-0 ${
            location.pathname === item.path
              ? "text-primary font-semibold"
              : "hover:text-text-highlight/80"
          }`}
          onClick={() => setIsOpen(false)}
        >
          {item.label}
        </Link>
      </li>
    )
  )}
</ul>

      </div>
    </nav>
  );
};

export default Navbar;
